let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d7pvU")).then(() => parcelRequire('1znBb'));